/**
 * Componente de Logo
 * Logo reutilizável usado em todo o aplicativo
 * Adapta-se automaticamente ao contexto da aplicação
 */

import { ContextIcon } from './ContextIcon'
import { useContextKey } from '@/modules/units/contexts/UnitContext'

import type { UnitContext } from '@/modules/units/contexts/UnitContextTypes';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  context?: UnitContext
}

const sizeMap = {
  sm: { container: 'h-12 w-12', icon: 'h-6 w-6' },
  md: { container: 'h-16 w-16', icon: 'h-8 w-8' },
  lg: { container: 'h-20 w-20', icon: 'h-10 w-10' },
}

const contextsWithPng = new Set<UnitContext>(['billing', 'pricing', 'poultry'])

export function Logo({ size = 'lg', className = '', context }: LogoProps) {
  const sizes = sizeMap[size]

  // Hook sempre chamado incondicionalmente (Rules of Hooks)
  const contextFromHook = useContextKey()
  // Prop > env default embutido no hook > 'farm'
  const appContext = (context || contextFromHook || 'farm') as UnitContext

  // Contextos com PNG: renderiza a imagem diretamente (ela já tem fundo e bordas próprias)
  if (contextsWithPng.has(appContext)) {
    return (
      <img
        src={`/icons/${appContext}/icon-192x192.png`}
        className={`${sizes.container} rounded-xl object-contain shadow-lg ${className}`}
        alt={appContext}
      />
    )
  }

  return (
    <div className={`flex ${sizes.container} items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-900/30 shadow-lg ${className}`}>
      <ContextIcon context={appContext} className={`${sizes.icon} text-emerald-600 dark:text-emerald-400`} />
    </div>
  )
}
